/**
 * EmptyState — typographic-only empty state.
 *
 * Manifesto says: no illustrations, no blobs, no stock. A good empty state is
 * a single line of copy that tells the user what they're looking at and what
 * they can do next.
 */

import type { ReactNode } from "react";

export function EmptyState({
  heading,
  body,
  action,
}: {
  heading: string;
  body?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="empty-state">
      <div className="empty-state-heading">{heading}</div>
      {body && <div className="empty-state-body">{body}</div>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}
